import I18n from "app/pages/sales-intelligence/common-components/i18n/I18n";
import type { Translatable } from "app/pages/sales-intelligence/types";
import type { ReactNode } from "react";
import { CenteredFlexColumn } from "pro-features/styled components/StyledFlex/src/StyledFlex";
import { StyledImage, StyledSubTitle, StyledTitle, StyledView } from "./styles";

type Props = {
    title: Readonly<Translatable>;
    subtitle: Readonly<Translatable>;
    children?: ReactNode;
};

const ErrorContentBase = ({ title, subtitle, children }: Props) => {
    return (
        <StyledView data-automation="error-content-view">
            <StyledImage iconName="no-data-tree" />

            <CenteredFlexColumn>
                <I18n
                    element={StyledTitle}
                    translatable={title}
                />
                <I18n
                    element={StyledSubTitle}
                    translatable={subtitle}
                />
            </CenteredFlexColumn>

            {children}
        </StyledView>
    );
};

export default ErrorContentBase;
